module.exports = __webpack_public_path__ + "static/IMG-20201101-WA0015-4852151821eaefd0018c978f19fd390e.jpg";